import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPolicyPage } from "../features/legal/PrivacyPolicyPage.tsx";

export const Route = createFileRoute("/pa")({
  component: PrivacyPolicyPage,
});
